import { AwsDocument } from "./aws-document";

export class ProjectAwsDocument extends AwsDocument {
	ProjectID:number = 0;

	public constructor(data?:any){
		super(data);
		if (!data) return;
		this.ProjectID = data.ProjectID;
	}
}
